import * as React from "react"
import * as moment from "moment"
import AmortizationTable from "./amortization-table"
import {
	Bank,
	Loan,
	InterestVariation,
	RateVariation,
	ReimboursedCapitalVariation
} from "../../../model"

const Ids = {
	amount: "loan-amount",
	bank: "loan-bank",
	constantAmortization: ["loan-constantAmortization-true", "loan-constantAmortization-false"],
	contractedOn: "loan-contractedOn",
	duration: "loan-duration",
	variableRate: "loan-variableRate",
	number: "loan-number",
	perdiodicity: "loan-periodicity",
	rate: "loan-rate",
	simulate: "loan-simulate",
	subject: "loan-subject",
	detteRecuperable: "dette-recuperable"
}

export enum Names {
	Amount = "amount",
	Bank = "bank",
	ConstantAmortization = "constantAmortization",
	ContractedOn = "contractedOn",
	Duration = "duration",
	BankSelector = "bankSelector",
	Number = "number",
	Periodicity = "periodicity",
	Rate = "rate",
	Simulate = "simulate",
	Subject = "subject",
	VariableRate = "variableRate",
	Dette  = 'Dette'
}

export default class LoanDetailComponent
extends React.Component<LoanDetailComponentProps> {
	render() {
		const newBankLabel = this.props.newBankLabel
		const periodicities = [
			{ value: 1, text: "Annuelle" },
			{ value: 2, text: "Semestrielle" },
			{ value: 4, text: "Trimestrielle" },
			{ value: 12, text: "Mensuelle" }
		]
		const loading = this.props.loading
		const loadingClassName = loading ? "is-loading" : ""
		const bulmaInputControlClassName = `control ${loadingClassName}`
		const bulmaSelectControlClassName = "control"
		const bulmaSelectClassName = `select is-fullwidth ${loadingClassName}`
		const isAddContext = this.props.context === Context.Add
		const isEditContext = this.props.context === Context.Edit
		const isViewContext = this.props.context === Context.View
		const disabled = isViewContext || loading
		const newBank = this.props.newBank
		const numberPlaceholder = this.getNumberPlaceholder()
		const values = this.getInputValues(this.props.loan, newBankLabel)
		const title = isAddContext ? "Ajouter un emprunt" : `Détail de l'emprunt ${values.number}`.trim()

		return <section className="section">
			<form onSubmit={this.props.onSubmit}>
				<header className="hero">
					<div className="hero-body">
						<div className="level">
							<div className="level-left">
								<div>
									<h2 className="title">{title}</h2>
									{!isAddContext && values.subject && <h3 className="subtitle">{values.subject}</h3>}
								</div>
							</div>
							<div className="level-right">
								<div className="level-item">
									{isAddContext && (
										<button className="button is-primary" disabled={disabled} title="Créer l'emprunt">
											<span className="icon"><i className="fas fa-check"></i></span>
											<span>Créer l'emprunt</span>
										</button>
									)}
									{isViewContext && !this.props.consulted && (
										<button className="button" disabled={loading} onClick={this.props.onClickEdit} type="button" title="Modifier l'emprunt">
											<span className="icon"><i className="fas fa-pencil-alt"></i></span>
										</button>
									)}
									{isEditContext && (
										<div className="buttons">
											<button className={`button is-primary ${loadingClassName}`} disabled={disabled} title="Valider les modifications">
												<span className="icon"><i className="fas fa-check"></i></span>
											</button>
											<button className={`button is-danger ${loadingClassName}`} disabled={disabled} onClick={this.props.onClickDelete} title="Supprimer l'emprunt" type="button">
												<span className="icon"><i className="fas fa-trash-alt"></i></span>
											</button>
											<button className={`button ${loadingClassName}`} onClick={this.props.onClickCancel} type="button" title="Annuler les modifications">
												<span className="icon"><i className="fas fa-ban"></i></span>
											</button>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</header>

				<section className="columns is-desktop">
					<div className="column is-three-fifths-desktop">

						{/* Emprunt simulé */}
						<div className="field is-horizontal">
							<div className="field-label is-normal"><label className="label" htmlFor={Ids.number}>Emprunt simulé</label></div>
							<div className="field-body">
									<div className="control">
										<label className="checkbox">
											<input
											checked  = {values.simulate}
											disabled = {disabled}
											id       = {Ids.simulate}
											name     = {Names.Simulate}
											onChange = {this.props.onInputChange}
											type     = "checkbox"
											style    = {{ marginTop: '12px' }} /></label>
									</div>
								</div>
						</div>
						{/* Fin Emprunt simulé */}

						{/* Numéro de l'emprunt */}
						<div className="field is-horizontal">
							<div className="field-label is-normal"><label className="label" htmlFor={Ids.number}>Numéro</label></div>
							<div className="field-body">
								<div className="field">
									<div className={bulmaInputControlClassName}>
										<input
										className   = "input"
										disabled    = {disabled}
										id          = {Ids.number}
										name        = {Names.Number}
										onChange    = {this.props.onInputChange}
										placeholder = {numberPlaceholder}
										type        = "text"
										value       = {values.number} />
									</div>
								</div>
							</div>
						</div>
						{/* Fin Numéro de l'emprunt */}

						{/* Objet de l'emprunt */}
						<div className="field is-horizontal">
							<div className="field-label is-normal"><label className="label" htmlFor={Ids.subject}>Objet</label></div>
								<div className="field-body">
									<div className="field">
									<div className={`${bulmaInputControlClassName} has-icons-right is-expanded`}>
											<input
											className   = "input"
											disabled    = {disabled}
											id          = {Ids.subject}
											name        = {Names.Subject}
											onChange    = {this.props.onInputChange}
											placeholder = "Opération de renouvellement urbain"
											type        = "text"
											value       = {values.subject}
											required />
										</div>
									</div>
									<div className="field">
									<div className="control">
										<label className="checkbox">
											<input
											checked  = {values.detteRecuperable}
											disabled = {disabled}
											id       = {Ids.detteRecuperable}
											name     = {Names.Dette}
											onChange = {this.props.onInputChange}
											type     = "checkbox" /> Dette récupérable</label>
									</div>
								</div>
								</div>
							</div>
						{/* Fin Objet de l'emprunt */}


						{/* Banque de l'emprunt */}
						{!values.simulate &&
						<div className="field is-horizontal">
							<div className="field-label is-normal"><label className="label" htmlFor={Ids.bank}>Banque</label></div>
								<div className="field-body">
									<input
									checked={!newBank}
									name={Names.BankSelector}
									onChange={this.props.onInputChange}
									required
									style={{ marginTop: '11px' }}
									type="radio"
									value={0} />
									&nbsp;
									<div className="field">
										<div className={`select is-fullwidth ${loading ? "is-loading" : ""}`}>
											<select
											className = "input"
											disabled  = {disabled || newBank}
											id        = {Ids.bank}
											name      = {Names.Bank}
											onChange  = {this.props.onInputChange}
											value     = {values.bank}
											required>
											<option disabled value="">Aucune</option>
											{this.props.banks.map((b, i) =>
												<option key={i} value={b.id} >{b.label}</option>
											)}
											</select>
										</div>
									</div>
									<input
									checked={newBank}
									name={Names.BankSelector}
									onChange={this.props.onInputChange}
									required
									style={{ marginTop: '11px' }}
									type="radio"
									value={1} />
									&nbsp;
									<div className={bulmaInputControlClassName}>
										<input
										className   = "input"
										disabled    = {disabled || !newBank}
										id          = {Ids.bank}
										name        = {Names.Bank}
										onChange    = {this.props.onInputChange}
										placeholder = "Nouvelle banque"
										type        = "text"
										value       = {values.newBankLabel}
										required />
									</div>
							</div>
						</div>
						}
						{/* Fin Banque de l'emprunt */}

						{/* Montant de l'emprunt */}
						<div className="field is-horizontal">
							<div className="field-label is-normal"><label className="label" htmlFor={Ids.amount}>Montant</label></div>
							<div className="field-body">
								<div className="field">
									<div className={`${bulmaInputControlClassName} has-icons-right is-expanded`}>
										<input
										className   = "input"
										disabled    = {disabled}
										id          = {Ids.amount}
										name        = {Names.Amount}
										onChange    = {this.props.onInputChange}
										placeholder = "1500000"
										type        = "number"
										value       = {values.amount}
										required />
										{loading || <span className="icon is-small is-right"><i className="fas fa-euro-sign"></i></span>}
									</div>
								</div>
							</div>
						</div>
						{/* Fin Montant de l'emprunt */}

						{/* Date de l'emprunt */}
						<div className="field is-horizontal">
							<div className="field-label is-normal"><label className="label" htmlFor={Ids.contractedOn}>Date de premier encaissement</label></div>
							<div className="field-body">
								<div className="field">
									<div className={bulmaInputControlClassName}>
										<input
										className = "input"
										disabled  = {disabled}
										id        = {Ids.contractedOn}
										name      = {Names.ContractedOn}
										onChange  = {this.props.onInputChange}
										type      = "date"
										value     = {values.contractedOn}
										required />
									</div>
								</div>
							</div>
						</div>
						{/* Fin Date de l'emprunt */}

						{/* Durée de l'emprunt */}
						<div className="field is-horizontal">
							<div className="field-label is-normal"><label className="label" htmlFor={Ids.duration}>Durée</label></div>
							<div className="field-body">
								<div className="field has-addons">
									<span className={`${bulmaInputControlClassName} is-expanded`}>
										<input
										className   = "input"
										disabled    = {disabled}
										id          = {Ids.duration}
										name        = {Names.Duration}
										onChange    = {this.props.onInputChange}
										placeholder = "120"
										type        = "number"
										value       = {values.duration}
										required />
									</span>
									<span className="control">
										<a className="button is-static">mois</a>
									</span>
								</div>
							</div>
						</div>
						{/* Fin Durée de l'emprunt */}

						{/* Périodicité de l'emprunt */}
						<div className="field is-horizontal">
							<div className="field-label is-normal"><label className="label" htmlFor={Ids.perdiodicity}>Périodicité</label></div>
							<div className="field-body">
								<div className="field">
									<div className={bulmaSelectControlClassName}>
										<div className={bulmaSelectClassName}>
											<select
											disabled = {disabled}
											id       = {Ids.perdiodicity}
											name     = {Names.Periodicity}
											onChange = {this.props.onInputChange}
											value    = {values.periodicity}>
												{periodicities.map((p, i) => <option key={i} value={p.value}>{p.text}</option>)}
											</select>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* Fin Périodicité de l'emprunt */}

						{/* Taux de l'emprunt */}
						<div className="field is-horizontal">
							<div className="field-label is-normal"><label className="label" htmlFor={Ids.rate}>Taux</label></div>
							<div className="field-body">
								<div className="field">
									<div className={`${bulmaInputControlClassName} has-icons-right is-expanded`}>
										<input
										className   = "input"
										disabled    = {disabled}
										id          = {Ids.rate}
										name        = {Names.Rate}
										onChange    = {this.props.onInputChange}
										placeholder = "4.5"
										step        = {0.01}
										type        = "number"
										value       = {values.rate}
										required />
										{loading || <span className="icon is-small is-right"><i className="fas fa-percent"></i></span>}
									</div>
								</div>
								<div className="field">
									<div className="control">
										<label className="checkbox">
											<input
											checked  = {values.variableRate}
											disabled = {disabled}
											id       = {Ids.variableRate}
											name     = {Names.VariableRate}
											onChange = {this.props.onInputChange}
											type     = "checkbox" /> Variable</label>
									</div>
								</div>
							</div>
						</div>
						{/* Fin Taux de l'emprunt */}

						{/* Type de l'emprunt */}
						<div className="field is-horizontal">
							<div className="field-label"><label className="label" htmlFor={Ids.constantAmortization[0]}>Type d'emprunt</label></div>

							<div className="field-body">
								<div className="field is-narrow">
									<div className="control">
										<label className="radio">
											<input
											checked={values.constantAmortization}
											disabled={disabled || !values.rate}
											id={Ids.constantAmortization[0]}
											name={Names.ConstantAmortization}
											onChange={this.props.onInputChange}
											required
											type="radio"
											value={1} /> Emprunt à amortissement constant
										</label>
									</div>
									<div className="control">
										<label className="radio">
											<input
											checked={!values.constantAmortization}
											disabled={disabled || !values.rate}
											id={Ids.constantAmortization[1]}
											name={Names.ConstantAmortization}
											onChange={this.props.onInputChange}
											required
											type="radio"
											value={0} /> Emprunt à annuité constante
										</label>
									</div>
								</div>
							</div>
						</div>
						{/* Fin Type de l'emprunt */}
					</div>
				</section>

				<section>
					<AmortizationTable
					loan={this.props.loan}
					isAddContext={isAddContext}
					isEditContext={isEditContext}
					isViewContext={isViewContext}
					onInterestVariationsChange={this.props.onInterestVariationsChange}
					onRateVariationsChange={this.props.onRateVariationsChange}
					onReimboursedCapitalVariationsChange={this.props.onReimboursedCapitalVariationsChange} />
				</section>
			</form>
		</section>
	}

	private getInputValues(loan: Loan, newBankLabel: string): InputValues {
		return loan
		? {
				amount: loan.amount ? loan.amount.toString() : "",
				bank: loan.bank && loan.bank.id ? loan.bank.id.toString() : "",
				constantAmortization: undefined === loan.constantAmortization ? true : loan.constantAmortization,
				contractedOn: loan.contractedOn ? moment(loan.contractedOn).format("YYYY-MM-DD") : "",
				duration: loan.duration ? loan.duration.toString() : "",
				variableRate: loan.variableRate,
				newBankLabel: newBankLabel || "",
				number: loan.number || "",
				periodicity: loan.periodicity || 1,
				rate: null !== loan.rate ? (Math.round(loan.rate * 100 * 1000) / 1000).toString() : "",
				simulate: loan.simulate ? loan.simulate : false,
				subject: loan.subject || "",
				rateVariations: loan.rateVariations,
				detteRecuperable:loan.detteRecuperable
			}
		: {
				amount: "",
				bank: "",
				constantAmortization: true,
				contractedOn: "",
				duration: "",
				variableRate: false,
				newBankLabel: "",
				number: "",
				periodicity: 1,
				rate: "",
				simulate: false,
				subject: "",
				rateVariations: [],
				detteRecuperable: false,
			};
	}

	private getNumberPlaceholder(): string {
		const datePart = (new Date()).toISOString().substr(0, 10).replace("-", "")
		return `EM-${datePart}-001`
	}
}

export enum Context { Add, Edit, View }

export interface LoanDetailComponentProps {
	newBankLabel: string
	banks: Bank[]
	consulted: boolean
	context: Context
	loading: boolean
	loan: Loan
	newBank: boolean
	onClickCancel(e: React.SyntheticEvent<Element>): void
	onClickEdit(e: React.SyntheticEvent<Element>): void
	onClickDelete(e: React.SyntheticEvent<Element>): void
	onInputChange(e: React.SyntheticEvent<Element>): void
	onInterestVariationsChange(interestVariations: InterestVariation[]): void
	onRateVariationsChange(rateVariations: RateVariation[]): void
	onReimboursedCapitalVariationsChange(reimboursedCapitalVariations: ReimboursedCapitalVariation[]): void
	onSubmit(e: React.SyntheticEvent<Element>): void
}

interface InputValues {
	amount: string,
	bank: string,
	constantAmortization: boolean,
	contractedOn: string,
	duration: string,
	variableRate: boolean,
	newBankLabel: string,
	number: string,
	periodicity: number,
	rate: string,
	simulate: boolean,
	subject: string,
	rateVariations: RateVariation[],
	detteRecuperable: boolean,
}


// WEBPACK FOOTER //
// ./src/component/debt/loan-detail/loan-detail-component.tsx